import React from 'react';
import aboutImage from '../../assets/about-us.png'; // Replace with your actual image path
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
  const navigate = useNavigate();

  const handleReadMoreClick = () => {
    navigate('/about');
  };

  return (
    <div className="w-full py-4 sm:py-6 px-2 sm:py-8 sm:px-6">
      {/* Heading */}
      <div className="text-center mb-6 sm:mb-16">
        <h2 className="text-3xl sm:text-4xl text-[#011B5D] font-bold">About Us</h2>
        <div className="border-b-4 border-[#011B5D] w-24 sm:w-48 mx-auto mt-1 sm:mt-2"></div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row justify-evenly  px-4 space-y-3 md:space-y-0 md:space-x-6">
        
        {/* Text and Button */}
        <div className="text-center md:text-left md:w-3/6">
          <p className="text-sm sm:text-base md:text-lg leading-5 sm:leading-normal md:leading-relaxed text-justify">
            We have pleasure to introduce ourselves as one of the leading Import Export Advisors & Business Consultants.
            We have experience in this field since 2003 and started GELS in 2022. Global Exim and Logistics Solutions (GELS)
            is a multi-disciplinary consultancy organization engaged in various consultancy with respect to Indirect Taxation,
            DGFT Licensing, Customs Brokerage, Freight Forwarding, Refunds, and more. Our business-oriented approach and
            experience in Foreign Trade Policy matters allow us to effectively guide our clients.
          </p>
          <button onClick={handleReadMoreClick} className="bg-[#FFBD12] text-md text-black my-6 py-1 px-8 rounded shadow-md">
            Read More
          </button>
        </div>

        {/* Image */}
        <div className="w-full md:w-2/5 pb-6 md:mb-0 md:mt-0">
          <img src={aboutImage} alt="About Us" className="w-full max-h-64 md:max-h-80 rounded-lg shadow-md md:mr-4" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
